export enum WaiverCodeType {
  Normal = 1,
  Cabin,
  Class,
}
